module.exports = "<app-loading class=\"cargando\"></app-loading>\n<app-navbar *ngIf=\"this.auth.usuarioActivo && this.router.url!='/preconsulta' && this.router.url!='preservicio'\"></app-navbar>\n<router-outlet class=\"container main-container\"></router-outlet>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main